import { Button, DownloadIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { saveAs } from "file-saver";
import { useDownloadLocaleStrings } from "../../hooks/localestrings/useDownloadLocaleStrings";
//import { useDownloadLocaleStrings } from "../../../hooks/libraries/localeStringss/useDownloadLocaleStrings";

type LocaleStringsDownloadButtonProps = {
  productCode: string;
  cultureCode: string | undefined;
};

export const LocaleStringsDownloadButton: React.FC<LocaleStringsDownloadButtonProps> = ({
  productCode,
  cultureCode
}) => {
  const { t } = useTranslation();
  const [downloadLocaleStrings, isLoading] = useDownloadLocaleStrings(productCode, cultureCode);

  return (
    <Button
      disabled={cultureCode == undefined}
      key="localestrings-download"
      icon={<DownloadIcon />}
      onClick={async () => {
        const response = await downloadLocaleStrings();
        if (response?.blob && response?.filename && response?.filename !== "") {
          saveAs(response?.blob, response?.filename);
        }
        else {
          console.log("It is not blob or Invalid filename");
        }
      }}
      loading={isLoading}
    >
      {t("localestrings.actions.download.button")}
    </Button>
  );
};
